<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1" id="map1">
<span class="reference" href="#/Text/Section0044" id="id-701555607188239981" title="Link target outside of Sample"><img alt="" class="calibre6" id="id-2163887914411563924" src="Images/img0094.jpg"/></span>
<p class="caption">MAP<br class="calibre5"/>
<span class="smaller">of the</span><br class="calibre5"/>
<span class="larger">NOVAYA ZEMLYA SEA</span><br class="calibre5"/>
<span class="smaller">for the</span><br class="calibre5"/>
Austro-Hungarian<br class="calibre5"/>
Expeditions.</p>
</div>
<p class="calibre3"><span id="pgepubid00029" title="[1]"><a class="reference" id="Page_1" title="[1]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?07eab9d6